var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgConsole = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.763 15.507s-1.4-4.2-5.101-4c0 0-1.1.1-2.4.6l-2.9.1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.362 15.507s1.4-4.2 5.1-4c0 0 1.1.1 2.4.6l2.9.1M20.362 24.707h4.8s.6-.1 1.5.6c0 0 3.6 4.2 5 3.8 0 0 1.6-.8 1.9-3.1s-.5-5.8-2-9c0 0-.8-2.4-2.7-3.4 0 0-2.8-1.3-4-.2l-1.899 2.1h-2.6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.763 24.707h-4.8s-.6-.1-1.5.6c0 0-3.6 4.2-5 3.8 0 0-1.6-.8-1.9-3.1s.5-5.8 2-9c0 0 .8-2.4 2.7-3.4 0 0 2.8-1.3 4-.2l1.9 2.1h2.6M20.862 12.207a1.4 1.4 0 1 1 .001 2.8 1.4 1.4 0 0 1 0-2.8ZM22.562 17.907a.2.2 0 1 1 0 .4.2.2 0 0 1 0-.4Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.562 17.907a.2.2 0 1 1 0 .4.2.2 0 0 1 0-.4ZM23.463 20.307a1.4 1.4 0 1 1-.002 2.8 1.4 1.4 0 0 1 .002-2.8ZM18.062 20.307a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8ZM14.163 15.707a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8ZM26.562 15.907a.2.2 0 1 1 0 .4.2.2 0 0 1 0-.4ZM26.562 17.907a.2.2 0 1 1 0 .4.2.2 0 0 1 0-.4ZM27.562 16.907a.2.2 0 1 1 0 .4.2.2 0 0 1 0-.4ZM25.562 16.907a.2.2 0 1 1 0 .4.2.2 0 0 1 0-.4Z"
}))));
export default SvgConsole;